import { ReactElement } from 'react';

import { css } from '@emotion/react';
import { LocalResultType } from '@type/web/fraud';

import Icon from '@components/common/Icon/Icon';

import {
  emphasizeText,
  gridItem,
  infoButton,
} from '../fraudSearchResult.style';

export interface LocalResultDetailTypeProps {
  props: {
    handleToggle: (text?: string | undefined) => void;
    infoText: string;
    reportPath: LocalResultType['report_path'];
  };
}

export default function ResultDetailCs({
  props: { handleToggle, infoText, reportPath },
}: LocalResultDetailTypeProps): ReactElement {
  return (
    <div css={[gridItem, resultCS]}>
      <button
        type="button"
        aria-label="info"
        css={infoButton}
        onClick={() => handleToggle(infoText)}
      >
        <Icon icon="info" />
      </button>
      <p className="title">등록된 피해건수</p>
      <p className="content">
        <span css={emphasizeText(true)}>{reportPath?.manual_cs}</span> 건
      </p>
    </div>
  );
}

const resultCS = css`
  p {
    margin-top: 10px;
  }
  grid-column: 1/2;
`;
